import '@/modules/card';
import Swiper from 'swiper';
import SwiperCore, { Pagination, Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Pagination, Navigation, Scrollbar]);

export default class ProductCarouselToggle {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * product carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.pagination = this.sliderElement.querySelector('.swiper-pagination');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.slideToggles = this.sliderElement.closest('.wrap')?.querySelectorAll('.js-slides-toggle') || [];
        this.slideToggleAll = this.sliderElement.closest('.wrap')?.querySelector('.js-slides-all');
        this.slides = this.sliderElement.querySelectorAll('.js-slide');
        this.init()
    }

    init() {
        const swiper = new Swiper(this.sliderElement, {
            slidesPerView: 1,
            spaceBetween: 20,
            threshold: 10,
            pagination: {
                el: this.pagination
            },
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 4,
                }
            }
        });

        // Click event for all slides toggle
        if (this.slideToggleAll) {
            this.slideToggleAll.addEventListener('click', () => {
                this.slides.forEach(slide => {
                    slide.classList.remove('hidden');
                });

                this.slideToggleAll.classList.add('button--pink');
                this.slideToggles.forEach(button => button.classList.remove('button--pink'));

                swiper.slideTo(0);
                swiper.scrollbar.setTranslate(0);
                swiper.update();
            });
        }

        if (this.slideToggles) {
            this.slideToggles.forEach(button => {
                button.addEventListener('click', () => {
                    const buttonType = button.dataset.type;

                    this.slides.forEach(slide => {
                        const collections = (slide.dataset.collections || '').split('|').filter(Boolean);
                        if (collections.includes(buttonType)) {
                            slide.classList.remove('hidden');
                        } else {
                            slide.classList.add('hidden');
                        }
                    });

                    swiper.slideTo(0);
                    swiper.scrollbar.setTranslate(0);
                    swiper.update();

                    this.slideToggleAll.classList.remove('button--pink');
                    this.slideToggles.forEach(b => b.classList.remove('button--pink'));
                    button.classList.add('button--pink');
                });
            });
        }
    }
}
